import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  max-width: 100%;
  padding: 4px;
  cursor: pointer;
  align-items: center;
`;

const Label = styled.span`
  font-size: 0.8rem;
`;

export default function FiterCheckbox(props) {
  const { label, checked, setChecked } = props;

  return (
    <Container onClick={() => setChecked(!checked)}>
      <input type="checkbox" checked={checked} />
      <Label> {label} </Label>
    </Container>
  );
}
